export default "__VITE_ASSET__pRynoxoW__"